import React, { useEffect, useMemo, Suspense } from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { viteEnv } from '../../lib/viteEnv';
setTimeout(()=>{try{import('./index.css')}catch{}},1000);

const FORCE_RELOAD_THRESHOLD_MS = 30000;

const SuperSuspense = ({ children, noLoading }) =>
{
	return (
		<ComponentErrorBoundary>
			<Suspense fallback={<div className="suspense-loading">{viteEnv!=='chrome'&&!noLoading && <img src="/images/icons/sleepy.gif" alt="Loading..." />}</div>}>
				{children}
			</Suspense>
		</ComponentErrorBoundary>
	)
}

export default SuperSuspense;

const SuspenseError = ({ error }) =>
{
	const network = useMemo(()=>error?.name==='ChunkLoadError'||/Loading chunk|dynamically imported module|Importing a module script failed/i.test(error?.message), [error]);

	useEffect(()=>
	{
		if(!network) return;
		const url = new URL(window.location.href);
		const forceReload = Number(url.searchParams.get('forceReload'));
		const now = Date.now();
		if (!forceReload || now-forceReload >FORCE_RELOAD_THRESHOLD_MS)
		{
			url.searchParams.set('forceReload', now);
			window.location.replace(url);
		}
	}, [network]);

	return (
		<div className="suspense-failed-container">
			<div className="row">
				<div className="icon"><AlertCircle /></div>
				<div className="content hide-if-topbar">
					<h3 className="title ">
						{network ? 'This component failed to load' : 'An unexpected error has occurred'}
					</h3>

					<p className="message">
						{network ? 'Please check your internet connection, then try again.' : 'If this error persists, please reach out to philip@koalaquill.com for support.'}
					</p>

					<button
						className="retry-btn"
						onClick={()=>window.location.reload()}
					>
						<RefreshCw className="hide-if-topbar" />
						Refresh this page
					</button>

					<details className="details" open={true}>
						<summary className="summary">Error details</summary>
						<div className="error-box">
							{error?.message}
						</div>
					</details>
				</div>
			</div>
		</div>
	);
}

class ComponentErrorBoundary extends React.Component
{
	constructor(props)
	{
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error)
	{
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo)
	{
		console.error('Component runtime error:', error, errorInfo);
	}

	render()
	{
		return this.state.hasError
			? <SuspenseError 
				error={this.state.error} 
			/>
			: this.props.children;
	}
}
